import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=45124c6b&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"
import style0 from "./commentList.vue?vue&type=style&index=0&id=45124c6b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45124c6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45124c6b')) {
      api.createRecord('45124c6b', component.options)
    } else {
      api.reload('45124c6b', component.options)
    }
    module.hot.accept("./commentList.vue?vue&type=template&id=45124c6b&scoped=true", function () {
      api.rerender('45124c6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/calendar/components/commentList.vue"
export default component.exports